import React, {useEffect, useRef, useState} from 'react';
import { useTypedTranslation } from '@app/hooks';
import { ErrorBlock, ButtonSubmit, PasslyTextField } from '@app/components';
import { ResetPasswordErrorType } from '@app/models';
import { basicService } from '@app/services';
import { FormControl, Link } from '@material-ui/core';
import { returnToLogin } from '../helpers';
import { SetLoginForm } from '@app/models';

interface IProps {
    isError: ResetPasswordErrorType;
    onSubmit: (username: string) => void;
    isLoading?: boolean;
    setLoginForm?: SetLoginForm;
}

export const ResetPasswordValidate: React.SFC<IProps> = ({ onSubmit, isError, isLoading, setLoginForm }) => {
    const { translation } = useTypedTranslation();
    const inputRef = useRef<HTMLInputElement>(null);
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const queryString = basicService.getQueryVariable('user');

        if (inputRef.current && !!queryString) {
            inputRef.current.value = queryString;
            setUserName(queryString);
        }
    }, []);

    const onUsernameChange = (e: any) => {
        const { value } = e.target;
        setUserName(value);
    };

    const onResetPasswordSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();

        onSubmit(userName);
    };

    return (
        <>
            <h1>{translation('NEED_HELP')}</h1>
            <ErrorBlock className='forgot-password__error' isError={isError.isUsernameInvalid} errorMessage={translation('RESET_USERNAME_INVALID')} />
            <p className='forgot-password__form-text'>{translation('RESET_CHECK_USERNAME')}</p>

            <form>
                <FormControl fullWidth>
                    <PasslyTextField
                        inputRef={inputRef}
                        label={'USERNAME'}
                        type='text'
                        onChange={onUsernameChange}
                        id='username-input'
                        name='username'
                        error={isError.isEmptyUsername}
                        helperText={isError.isEmptyUsername && translation('EMPTY_FIELD_ERROR')}
                        fullWidth
                    />
                </FormControl>
                <div className='forgot-password__buttons'>
                    <ButtonSubmit onClick={onResetPasswordSubmit} className='forgot-password__button-next' isLoad={!!isLoading} buttonText={translation('RESET_NEXT')} isDisabled={!!isLoading} disableRipple={true} />
                    <Link
                        className='forgot-password__button-cancel'
                        id='otherSigninOptionsButton'
                        color='primary'
                        underline='none'
                        onClick={returnToLogin(setLoginForm)}
                    >
                        {translation('CANCEL')}
                    </Link>
                </div>
            </form>
        </>
    );
};
